import { render, staticRenderFns } from "./waitExchange.vue?vue&type=template&id=44baab04"
import script from "./waitExchange.vue?vue&type=script&lang=js"
export * from "./waitExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports